import { select, call } from "redux-saga/effects";
import { selectAuthUserID } from "@/store/selectors/auth";
import { PayloadAction } from "@reduxjs/toolkit";
import { selectSuperuserSupermode } from "@/store/selectors/superuser";
import { usersMetaApi } from "@/api";
import { applySagaError } from "@/store/utils/saga";



export function* updateSelectedBrandIdSaga(action: PayloadAction<number>) {
    try {
      const supermode: boolean = yield select(selectSuperuserSupermode);
      if (supermode) return;
  
      const userId: string | undefined = yield select(selectAuthUserID);
  
      if (!userId) return;
  
      yield call(usersMetaApi.updateSelectedBrandId, { 
        userID: userId, 
        brandId: action.payload 
      });
    } catch (error) {
      yield* applySagaError(error, { 
        operationName: "brands.updateSelectedBrandId" 
      });
    }
  }